import { DialogAppSDK, PageAppSDK } from "@contentful/app-sdk";
import { Notification } from "@contentful/f36-components";
import { pollJobUntilComplete } from "../../api/backendClient";

export const OpenReviewModal = (project: any, sdk: PageAppSDK) => {

  return sdk.dialogs
    .openCurrent({
      title: "Project Files",
      width: "large",
      minHeight: "80vh",
      position: "center",
      parameters: {
        type: "ProjectFilesReview",
        data: project,
      },
    })
    .then((data) => {
      window.location.reload();
    });
};

export const OpenUpdateModal = (data: any, sdk: DialogAppSDK) => {

  return sdk.dialogs
    .openCurrent({
      title: "Project Files",
      width: 800,
      minHeight: "80vh",
      position: "center",
      allowHeightOverflow: false,
      parameters: {
        type: "TranslationReview",
        data: data,
      },
    })
    .then((resp) => {
      if(!resp) return;
      return resp;
    });
};

export const OpenNewRequestModal = (sdk: PageAppSDK) => {
  return sdk.dialogs
    .openCurrent({
      title: "New Request for Quote",
      width: 800,
      minHeight: "80vh",
      allowHeightOverflow: false,
      parameters: {
        type: "newRequest",
      },
    })
    .then((data: { jobId?: string; success?: boolean } | undefined) => {
      // If dialog was closed without submitting, do nothing
      if (!data || !data.success || !data.jobId) {
        return;
      }

      const jobId = data.jobId;
      const startTime = Date.now();
      const FIVE_MINUTES = 5 * 60 * 1000;
      let hasShownLongRunningMessage = false;

      // Show initial success notification (green)
      Notification.closeAll();
      Notification.setDuration(0); // Keep visible until we close it
      Notification.success("Request submitted successfully. Processing in background...");

      // Poll for job completion
      pollJobUntilComplete(jobId, (job) => {
        const elapsedTime = Date.now() - startTime;

        // Check if job is taking more than 5 minutes
        if (elapsedTime > FIVE_MINUTES && !hasShownLongRunningMessage) {
          hasShownLongRunningMessage = true;
          Notification.closeAll();
          Notification.setDuration(0);
          Notification.info("Process is taking longer than expected. You can check the status later.");
          return;
        }

        // Update notification with progress (don't update if already showing long-running message)
        if (job.status === 'processing' && !hasShownLongRunningMessage) {
          Notification.closeAll();
          Notification.setDuration(0);
          Notification.info(`Processing translation... ${job.progress}%`);
        }
      }).then((completedJob) => {
        // Job completed successfully
        Notification.closeAll();
        const resultCount = completedJob.result?.translatedCount || completedJob.result?.submittedCount || 0;
        const failedCount = completedJob.failedItems?.length || 0;

        if (failedCount > 0) {
          Notification.setDuration(5000);
          Notification.warning(`Translation completed with ${failedCount} failed item(s). ${resultCount} item(s) processed successfully.`);
        } else {
          Notification.setDuration(3000);
          Notification.success(`Translation completed successfully. ${resultCount} item(s) processed.`);
        }

        // Reload to refresh the quotes/projects list
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }).catch((error) => {
        // Job failed
        Notification.closeAll();
        Notification.setDuration(0);
        Notification.error("Translation failed: " + error.message);
      });
    });
};
